export interface CommercialClientComment {
  id?: string;
  text?: string;
  authorId?: string;
  authorName?: string;
  createdDate?: string;
}

/** Filial do cliente: tratamento fiscal usado no simulador Encomenda. */
export interface CommercialClientBranch {
  id?: string;
  name?: string | null;
  /** Só dígitos (14). */
  cnpj: string;
  state: string;
}

export const BRAZIL_STATES = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR",
  "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO",
];

export interface CommercialClient {
  id?: string;
  companyId?: string;
  name?: string;
  cnpj?: string;
  status?: string;
  honorariumPercent?: number | null;
  negotiatedMarginPercent?: number | null;
  analyst?: string;
  responsible?: string;
  commercialResponsible?: string;
  commercialMaintenance?: string;
  // Agentes comissionados (Gestão › Comercial).
  agent1?: string | null;
  agent2?: string | null;
  // Somente leitura: Empresa/Operação do cadastro da empresa vinculada.
  companyType?: number | null;
  companyOperation?: string | null;
  dispatcher?: string;
  segment?: string;
  radar?: string;
  contract?: string;
  dossierNumber?: string;
  insuranceEndorsement?: string;
  internationalFreight?: string;
  city?: string;
  state?: string;
  contactName?: string;
  phone?: string;
  email?: string;
  abc?: string;
  followUpDate?: string | null;
  fob12Months?: string;
  notes?: string;
  notionPageId?: string;
  // Ficha operacional (Intranet). Somente leitura no Clientes Ativos.
  modality?: string | null;
  particularities?: string | null;
  followUpFrequency?: string | null;
  carrier?: string | null;
  services?: string | null;
  /** Pipe-delimited ("a@x|b@y"). */
  operationalEmails?: string | null;
  marginText?: string | null;
  financialCost?: string | null;
  proceduresCount?: number;
  createdDate?: string;
  comments?: CommercialClientComment[];
  branches?: CommercialClientBranch[];
  newCompanyName?: string;
  newCompanyCnpj?: string;
}

export const commercialStatuses = [
  "Prospect",
  "Contato",
  "Em negociação",
  "Proposta enviada",
  "Contrato fechado",
  "Perdido",
];

/** Editados tanto no Clientes Ativos quanto na Intranet: o PUT manda null quando a tela não mexeu (servidor mantém). */
export const SHARED_INTRANET_FIELDS = [
  "analyst", "dispatcher", "segment", "radar", "contract", "dossierNumber", "insuranceEndorsement", "internationalFreight",
] as const;
